import React from 'react';
import { StackPanel } from '@agilepoint/wat-react-ux';
import { ResetOrChangePasswordPane } from 'modules/reset-or-change-password/component/parts/reset-or-change-password-pane';
import { IChangePasswordPayload } from 'modules/shared/queries';

interface IChangePasswordProps {
    changePasswordHandler: (formData: IChangePasswordPayload) => Promise<any>;
}

export const ChangePassword = React.memo((props: IChangePasswordProps) => {
    const { changePasswordHandler } = props;
    return (
        <StackPanel height="500px" width="930px" alignment="center" justifyContent="center" orientation="horizontal">
            <ResetOrChangePasswordPane changePasswordHandler={changePasswordHandler} isReset={false} />
        </StackPanel>
    );
});
